import { Application } from "@hotwired/stimulus"

let application

export function getStimulusApplication() {
  if (!application) {
    application = Application.start()
    window.stimulusApplication = application
  }

  return application
}
